import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Spin,  } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import Header from "../Header/Header";

const VerifyEmail = () => {
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const token = query.get("token");

    if (token) {
      const verifyToken = async () => {
        try {
          const response = await axios.post(
            "https://sodastreamapi.azurewebsites.net/users/verify-email",
            { token }
          );
          if (response.status === 200) {
            setVerified(true);

            setTimeout(() => {
              navigate("/signin");
            }, 2000);
          } else {
            setVerified(false);
          }
        } catch (error) {
          setVerified(false);
        } finally {
          setLoading(false);
        }
      };
      verifyToken();
    } else {
      setLoading(false);
      setVerified(false);
    }
  }, [location.search, navigate]);

  return (
    <div>
      <Header
        title="VERIFY EMAIL"
        textBackground="VERIFY EMAIL"
        desktopHeight="100vh"
        backgroundImg="http://res.cloudinary.com/brabenjos/image/upload/v1729584914/sodastream/1729584914532.png"
        subTitle=""
      />
      <section className="relative w-full mt-[-35%] z-50 mb-5 p-4">
        <div className="md:relative gap-10 z-50 flex flex-col items-center justify-center w-full">
          <div className="bg-white rounded-xl border border-gray-300 relative sm:w-[50%] opacity-80 px-10 py-20 text-[#005D6E]">
            {loading ? (
              <div className="flex flex-col items-center">
                <div style={{ textAlign: "center", color: "green" }}>
                  <Spin size="large" tip="Verifying your email..." />
                </div>
                <p className="mt-4 text-lg text-gray-700">
                  Please wait while we verify your email.
                </p>
              </div>
            ) : verified ? (
              <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center mt-[-13%]">
                <CheckCircleOutlined className="text-green-500 text-6xl" />
                <h2 className="mt-4 text-2xl font-bold text-green-500">
                  Email Verified!
                </h2>
                <p className="mt-2 text-lg text-gray-700">
                  Thank you for verifying your email. You can now access your
                  account.
                </p>
                <p className="mt-6 text-lg text-gray-700">
                  Redirecting to Sign In...
                </p>
              </div>
            ) : (
              <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
                <CloseCircleOutlined className="text-red-500 text-6xl" />
                <h2 className="mt-4 text-2xl font-bold text-red-500">
                  Verification Failed
                </h2>
                <p className="mt-2 text-lg text-gray-700">
                  Something went wrong. Please try again or contact support.
                </p>
                <button
                  className="mt-6 bg-red-500 text-white py-2 px-4 rounded-lg shadow hover:bg-red-600 transition duration-300"
                  onClick={() => window.location.reload()}
                >
                  Retry Verification
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default VerifyEmail;
